import { type FC, type ReactNode } from "react";

export const PanelSection: FC<{
  children: ReactNode;
}> = ({ children }) => <section className="p-4">{children}</section>;
